import config from "environment";
import { getRequest } from "./client";
import {
  GetWorkspaceEmployeesContract,
  GetLinkRecordsForEmployeeContract,
} from "winslow-core";

const { baseApi } = config;

export async function apiGetEmployees(
  workspaceId: string
): Promise<GetWorkspaceEmployeesContract["Reply"]["data"]> {
  const fetchURL = `${baseApi}/employees/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetEmployees");
}

export async function apiGetEmployeeLinkRecords(
  employeeId: string,
  collectionId: string
): Promise<GetLinkRecordsForEmployeeContract["Reply"]["data"]> {
  const fetchURL = `${baseApi}/employees/${employeeId}/persona/${collectionId}`;
  const result = await getRequest<
    GetLinkRecordsForEmployeeContract["Reply"]["data"]
  >(fetchURL, "API/apiGetEmployeeLinkRecords");
  return result || null;
}

